<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/actives/list" color="blue">上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">檢視/修改活動資訊</p>

          <v-text-field
            v-model="tempData.active_name"
            :rules="[formRules.required]"
            :persistent-hint="true"
            label="活動名稱"
            outlined
          ></v-text-field>

          <v-text-field
              type="text"
              v-model.active_code="tempData.active_code"
              label="活動代碼"
              disabled
              outlined
            ></v-text-field>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="tempData.start_time"
                label="開始時間"
                :rules="[formRules.required]"
                readonly
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="tempData.start_time" locale="zh-cn" color="blue"></v-date-picker>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="tempData.end_time"
                label="結束時間"
                :rules="[formRules.required]"
                readonly
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="tempData.end_time" locale="zh-cn" color="blue"></v-date-picker>
          </v-menu>

        </v-card-text>
      </v-card>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!valid" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更活動資訊？" text />
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import activesApi from "@/api/actives";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      id: 0,

      activeInfo: {},
      tempData: {},

      dialog: false,

      valid: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.activeInfo = JSON.parse(JSON.stringify(res.data));
      this.tempData = JSON.parse(JSON.stringify(res.data));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.activeInfo));
    },

    submit() {
      activesApi
        .updateByID(this.id, {
          active_name: this.tempData.active_name,
          start_time: this.tempData.start_time,
          end_time: this.tempData.end_time,
          available: this.tempData.available
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.id = Number(this.$route.params.id);

    activesApi
      .getByID(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
